// Import Bootstrap CSS a JS
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "bootstrap-icons/font/bootstrap-icons.min.css"
import { plugin, defaultConfig } from '@formkit/vue'
import config from './formkit/formkit_config'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { vValidate } from "@/directives/validation"
import { vTooltip } from "@/directives/tooltip"
import { vRole} from "@/directives/role";
import './assets/css/tooltip.css'

const myApp = createApp(App);

// setup global properties
myApp.config.globalProperties.URL_API_BASE = process.env.VUE_APP_API_HOST;
myApp.config.globalProperties.URL_BASE = process.env.VUE_APP_URL_BASE;
myApp.directive('validate', vValidate);
myApp.directive('tooltip', vTooltip);
myApp.directive('role', vRole);
myApp.use(store).use(router).use(plugin, defaultConfig(config)).mount('#app');